<template>
  <div class="overview-container">
    <img id="logo" src="../assets/logo.png" alt="" />
    <div class="overview-introduction">
      <h1>
        ECCHR <br />
        Explore
      </h1>
      <h1 class="episode-series">Framing Human Rights</h1>
      <p>
        In our conversations, we discuss how to combine artistic and legal
        interventions to give more power to social movements. And we speak about
        the power the arts can have in the global fight against impunity.
      </p>

      <!-- <button @click="fullscreen()">Fullscreen</button>
      <button @click="closeFullscreen()">Exit Fullscreen</button> -->
    </div>

    <EpisodeCards />

    <div class="footer">
      <div class="meta-btn" @click="$router.push({ path: '/about' })">
        About this app
      </div>
      <div class="meta-btn" @click="$router.push({ path: '/impressum' })">
        Imprint/Privacy
      </div>
    </div>
  </div>
</template>

<script>
import EpisodeCards from "../components/EpisodeCards.vue";

export default {
  name: "Overview",
  components: {
    EpisodeCards,
  },
  props: {
    msg: String,
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    // fullscreen() {
    // const application = document.getElementById("app");
    // application.webkitRequestFullScreen();
    // if (application.requestFullscreen) {
    //   application.requestFullscreen();
    // } else if (application.msRequestFullscreen) {
    //   application.msRequestFullscreen();
    // }
    // } else if (application.webkitRequestFullscreen) {
    //   application.webkitRequestFullscreen();
    // }
    // },
    // closeFullscreen() {
    // document.exitFullscreen();
    //   document.webkitCancelFullScreen();
    // },
  },
};
</script>

<style scoped>
h1 {
  font-size: 28px;
  margin-bottom: 30px;
}

.overview-container {
  position: relative;
  margin-top: 35px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 25px;
  /* overflow-y: scroll; */
}

.overview-introduction {
  width: 75%;
  padding-left: 30px;
}

p {
  color: rgba(235, 235, 245, 0.6);
  margin-top: 40px;
  margin-bottom: 50px;
}
.episode-series {
  padding-top: 40px;
}

.meta-btn {
  color: rgb(160, 160, 160);
  background-color: rgb(44, 44, 44);
  width: fit-content;
  display: inline-block;
  margin-right: 15px;
  border-radius: 20px;
  padding: 10px 12px;
  font-size: 12px;
}

.meta-btn:hover {
  cursor: pointer;
}

.footer {
  padding-top: 90px;
  padding-left: 20px;
}

#logo {
  position: absolute;
  top: 9px;
  right: 20px;
  width: 130px;
}

button {
  margin-right: 20px;
  border-radius: 20px;
  border: none;
  padding: 8px 12px 8px 12px;
  background-color: rgb(43, 43, 43);
  color: rgb(161, 161, 161);
  margin-bottom: 20px;
}
</style>
